import { Message, MessageBox } from "element-ui";
import { UPLOAD_BASE_URL } from "@/utils/request";
import { formatDate as _formatDate, fmtTime as _fmtTime } from "@/utils/filter";
import { delMind as _delMind } from "@/utils/index";
import { excutePanel } from "@/components/excutePanel/index";
import store from "@/store/index";
import bus from "@/utils/bus";
export function copy(text, callback) {
  let tag = document.createElement("input");
  tag.setAttribute("id", "cp_hgz_input");
  tag.value = text + "";
  document.getElementsByTagName("body")[0].appendChild(tag);
  document.getElementById("cp_hgz_input").select();
  document.execCommand("copy");
  document.getElementById("cp_hgz_input").remove();
  if (callback) {
    callback(text);
  }
}

/**
 * @author {pan.liu}
 * 节流 防止重复点击 ****先执行
 * eg: throttle(()=>{},500)
 * 2020-7-7
 */
export const throttle = (function () {
  const timer = null;
  let startTime = Date.now();
  return function (func, delay = 200, showTip = true) {
    const curTime = Date.now();
    const remaining = delay - (curTime - startTime);
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      // timer = setTimeout(func, remaining);
      showTip && Message({ type: "warning", message: "操作太快" });
    }
  };
})();

/**
 * @author {pan.liu}
 * 防抖 防止重复响应 ****后执行
 * eg: debounce(()=>{},500)
 * 2020-11-16
 */
export const debounce = (function () {
  let timer = null;
  return function (func, delay = 200) {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
})();

/**
 * 文件下载
 * @author {pan.liu}
 * @param {blob} blobData
 * @param {string} filename 文件名
 * @param {function} successCallback 成功回调
 * 2020-7-7
 */
export const downloadFile = (blobData, filename, successCallback) => {
  const aLink = document.createElement("a");
  document.body.appendChild(aLink);
  aLink.style.display = "none";
  aLink.href = window.URL.createObjectURL(blobData);
  aLink.setAttribute("download", filename);
  aLink.click();
  document.body.removeChild(aLink);
  successCallback && successCallback();
};

/** 生成guid | 60bffed0-d4b4-19eb-326e-4735b305998e*/
export const guid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  function getGuid() {
    return (
      S4() +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      S4() +
      S4()
    );
  }
  return getGuid();
};

/** 深克隆 */
export const deepClone = (data) => {
  let res;
  if (Array.isArray(data)) {
    res = [];
    for (let i = 0; i < data.length; i++) {
      res.push(deepClone(data[i]));
    }
  } else if (Object.prototype.toString.call(data) === "[object Object]") {
    res = {};
    for (let key in data) {
      res[key] = deepClone(data[key]);
    }
  } else {
    res = data;
  }
  return res;
};

export const filterList = (target, key) => {
  let obj = {};
  target.map((it) => {
    obj[it[key]] = it;
  });
  return Object.values(obj);
};
export const filterListByKeyVal = (obj, key, val) => {
  return obj.filter((item) => {
    if (item[key] === val) {
      return item;
    }
  });
};
export const toFixedFix = (n, prec = 2) => {
  let k = Math.pow(10, prec);
  return "" + Math.round(n * k) / k;
};

/**
 * 清除el-tooltip 页面跳转之后的副作用
 * @author {yuping}
 * 2023-4-25
 *在table 中有使用el-tooptip,在跳转新页面之后仍然停留,造成原因不祥。所有在路由中清除一次副作用
 */
export const clearTooltipEffect = () => {
  let list = document.querySelectorAll(".el-tooltip__popper");
  if (list.length) {
    [].forEach.call(list, (item) => {
      item.style.display = "none";
    });
  }
};

//  根据文件名获取文件后缀
export function getFileSuffix(name) {
  if (typeof name != "string") return new Error("name is not a string");
  if (name.indexOf(".") != -1) {
    const arr = name.split(".");
    return arr[arr.length - 1];
  } else return "";
}

export function fullUrl(url) {
  const errorUrl = ""; // 默认打卡一个地址告诉他这是一个错误的网址。
  const prefix = UPLOAD_BASE_URL;
  const fullUrlReg = /^(((ht|f)tps?):\/\/)/;
  if (typeof url != "string") return errorUrl;
  if (fullUrlReg.test(url)) return url;
  if (url.startsWith("/")) return prefix + url;
  return errorUrl;
}

/* 小写金额转大写金额 */
export function toChineseMoney(money) {
  try {
    const cnNums = new Array(
      "零",
      "壹",
      "贰",
      "叁",
      "肆",
      "伍",
      "陆",
      "柒",
      "捌",
      "玖"
    );
    const cnIntRadice = new Array("", "拾", "佰", "仟");
    const cnIntUnits = new Array("", "万", "亿", "兆");
    const cnDecUnits = new Array("角", "分", "毫", "厘");
    const cnInteger = "整";
    const cnIntLast = "圆";
    const maxNum = 999999999999999.9999;
    let integerNum; //金额整数部分
    let decimalNum; //金额小数部分
    let chineseStr = ""; //输出的中文金额字符串
    let parts; //输出的中文金额字符串
    if (money == "" || !["string", "number"].includes(typeof money)) return "";
    money = typeof money == "string" ? parseFloat(money) : money;
    if (money >= maxNum) return "";
    if (money == 0) return cnNums[0] + cnIntLast + cnInteger;
    money = money.toString(); //转换为字符串
    if (money.indexOf(".") == -1) {
      integerNum = money;
      decimalNum = "";
    } else {
      parts = money.split(".");
      integerNum = parts[0];
      decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      let zeroCount = 0;
      let IntLen = integerNum.length;
      for (let i = 0; i < IntLen; i++) {
        let n = integerNum.substr(i, 1);
        let p = IntLen - i - 1;
        let q = p / 4;
        let m = p % 4;
        if (n == "0") zeroCount++;
        else {
          if (zeroCount > 0) chineseStr += cnNums[0];
          zeroCount = 0; //归零
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) chineseStr += cnIntUnits[q];
      }
      chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != "") {
      let decLen = decimalNum.length;
      for (let i = 0; i < decLen; i++) {
        let n = decimalNum.substr(i, 1);
        if (n != "0") chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
    if (chineseStr == "") chineseStr += cnNums[0] + cnIntLast + cnInteger;
    else if (decimalNum == "") chineseStr += cnInteger;
    return chineseStr;
  } catch (error) {
    console.warn("非法字符：", money);
  }
}
/* 时间格式化 */
export const formatDate = _formatDate;
export const fmtTime = _fmtTime;
/*  删除提示 */
export const delMind = _delMind;
/* 操作状态原因提示 */
export const prompt = (options) => {
  let {
    type,
    title,
    message,
    required = true,
    showInput = false,
    showClose = false /* 是否显示关闭按钮 */,
    showCancelButton = true /* 是否显示取消按钮 */,
    inputPattern = /^(?!\s*$).+/,
    inputErrorMessage = "请输入原因",
    inputPlaceholder = "请输入原因",
  } = options || {};
  inputPattern = inputPattern instanceof RegExp ? inputPattern : null;
  inputPattern = showInput && inputPattern && required ? inputPattern : null; //
  return new Promise((resolve) => {
    MessageBox.prompt(message, {
      type,
      title,
      showInput,
      inputPattern,
      showClose,
      showCancelButton,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      inputType: "textarea",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPlaceholder,
      inputErrorMessage,
      beforeClose: async (action, instance, close) => {
        const closeActionList = ["cancel", "close"];
        function done(c = true) {
          instance.showCancelButton = true;
          instance.confirmButtonLoading = false;
          // instance.confirmButtonText = "确定";
          return c && close();
        }
        let errMsg = "cancel";
        if (closeActionList.includes(action))
          !close() && !resolve({ errMsg }) && Message.info("操作取消");
        else {
          errMsg = "confirm";
          if (!showCancelButton) return !close() && resolve({ errMsg });
          instance.showCancelButton = false;
          instance.confirmButtonLoading = true;
          // instance.confirmButtonText = "执行中";
          const { inputValue } = instance;
          return resolve({ inputValue, done, errMsg });
        }
      },
    }).catch((_) => _);
  });
};

/*  登录/认证 提示  */
export const loginAuthTips = (options) => {
  const isObject = Object.prototype.toString.call(options) == "[object Object]";
  options = isObject ? options : {};
  const { auth = false } = options; //
  const { isLogin, isAuth } = store.getters;
  const result = auth ? isLogin && isAuth : isLogin;
  if (result) return true;
  const title = isLogin && auth ? "认证提示" : "登录提示";
  const tips = isLogin
    ? "您尚未认证，请先前往个人中心进行邮箱认证"
    : "您尚未登录，登录后方可继续当前操作";
  excutePanel({
    type: "warning",
    title,
    tips,
  }).$on("close", (action) => {
    action == "confirm" && bus.$emit("showLogin");
  });
  return false;
};
